/* AR States Map: shared renderer for the interactive US map. Idempotent.
   Used by ar-states-map snippet (laws hub, rebates hub, pickers, etc.). */
(function(){
  if(window.__arMapLoaded){return;}
  window.__arMapLoaded=true;

  var SVG_NS='http://www.w3.org/2000/svg';
  var dataCache=null, dataPromise=null;

  function fetchMapData(url){
    if(dataCache)return Promise.resolve(dataCache);
    if(dataPromise)return dataPromise;
    dataPromise=fetch(url,{cache:'force-cache'})
      .then(function(r){if(!r.ok)throw new Error('map http '+r.status);return r.json();})
      .then(function(d){dataCache=d;return d;})
      .catch(function(){dataPromise=null;return null;});
    return dataPromise;
  }

  function buildNameLookup(wrap){
    var map={};
    wrap.querySelectorAll('.ar-map__sr-list [data-state-code]').forEach(function(a){
      map[a.dataset.stateCode]={name:a.dataset.stateName||'',url:a.getAttribute('href')||''};
    });
    return map;
  }

  function initMap(wrap){
    if(wrap.__arMapBound)return;
    wrap.__arMapBound=true;

    var svg=wrap.querySelector('.ar-map__svg');
    var canvas=wrap.querySelector('.ar-map__canvas');
    var loading=wrap.querySelector('.ar-map__loading');
    var tooltip=wrap.querySelector('.ar-map__tooltip');
    var tooltipCode=wrap.querySelector('.ar-map__tooltip-code');
    var tooltipName=wrap.querySelector('.ar-map__tooltip-name');
    var select=wrap.querySelector('[data-ar-map-select]');
    var prefix=wrap.dataset.prefix||'/pages/';
    var highlight=(wrap.dataset.highlight||'').toUpperCase();
    var assetUrl=wrap.dataset.assetUrl;
    if(!svg||!assetUrl)return;

    var lookup=buildNameLookup(wrap);

    function showTooltip(x,y,code){
      if(!tooltip||!canvas)return;
      tooltip.hidden=false;
      tooltip.setAttribute('aria-hidden','false');
      if(tooltipCode)tooltipCode.textContent=code;
      if(tooltipName)tooltipName.textContent=(lookup[code]&&lookup[code].name)||'';
      var rect=canvas.getBoundingClientRect();
      var left=Math.max(8,Math.min(rect.width-8,x-rect.left));
      var top=Math.max(8,y-rect.top-14);
      tooltip.style.left=left+'px';
      tooltip.style.top=top+'px';
    }
    function hideTooltip(){
      if(!tooltip)return;
      tooltip.hidden=true;
      tooltip.setAttribute('aria-hidden','true');
    }

    fetchMapData(assetUrl).then(function(data){
      if(!data||!data.paths){
        if(loading)loading.textContent='Map unavailable, use the list below.';
        return;
      }
      svg.setAttribute('viewBox','0 0 '+data.width+' '+data.height);
      svg.setAttribute('preserveAspectRatio','xMidYMid meet');

      Object.keys(data.paths).forEach(function(code){
        var entry=lookup[code];
        var name=(entry&&entry.name)||code;
        var url=(entry&&entry.url)||(prefix+code.toLowerCase());

        var path=document.createElementNS(SVG_NS,'path');
        path.setAttribute('d',data.paths[code]);
        path.setAttribute('vector-effect','non-scaling-stroke');
        var cls='ar-map__path';
        if(code===highlight)cls+=' ar-map__path--highlighted';
        path.setAttribute('class',cls);
        path.setAttribute('tabindex','0');
        path.setAttribute('role','link');
        path.setAttribute('aria-label',name);
        path.dataset.code=code;

        path.addEventListener('click',function(){window.location.href=url;});
        path.addEventListener('keydown',function(e){
          if(e.key==='Enter'||e.key===' '){e.preventDefault();window.location.href=url;}
        });
        path.addEventListener('mouseenter',function(e){showTooltip(e.clientX,e.clientY,code);});
        path.addEventListener('mousemove',function(e){showTooltip(e.clientX,e.clientY,code);});
        path.addEventListener('mouseleave',hideTooltip);
        path.addEventListener('focus',function(){
          var bbox=path.getBoundingClientRect();
          showTooltip(bbox.left+bbox.width/2,bbox.top,code);
        });
        path.addEventListener('blur',hideTooltip);

        svg.appendChild(path);
      });

      if(loading)loading.remove();

      if(svg.addEventListener){
        svg.addEventListener('mouseleave',hideTooltip);
      }
    });

    if(select){
      select.addEventListener('change',function(){
        if(select.value)window.location.href=select.value;
      });
    }
  }

  function scan(){
    document.querySelectorAll('[data-ar-states-map]').forEach(initMap);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:reorder',scan);
})();
